import NotFound from './NotFound.container';

export default NotFound;
